/**
 * Hlavní bannery – Swiper s fade efektem a automatickým přehráváním.
 *
 * Swiper je globál z vendor bundle (swiper-bundle.min.js).
 *
 * Přístupnost (WCAG):
 *  - 2.2.2 Pause, Stop, Hide – tlačítko pauzy zastaví autoplay natrvalo
 *    (po vlastní pauze se přehrávání samo neobnoví).
 *  - 2.3.3 Animation from Interactions – při prefers-reduced-motion se autoplay
 *    nespustí vůbec a texty se neanimují (řeší CSS).
 *  - 2.4.3 Focus Order / 4.1.2 – neaktivní slidy dostávají `inert`. U fade efektu
 *    zůstávají všechny slidy na stejném místě jen s opacity 0, takže bez inertu
 *    by se dalo tabovat na neviditelné CTA.
 */
function initBanners() {
    const el = document.getElementById('banners-swiper');
    if (!el || typeof Swiper === 'undefined') return;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const autoplayBtn = el.querySelector('.banner-autoplay-btn');

    /**
     * Neaktivní slidy vyřadíme z fokusu i z odečítače.
     * `inert` implikuje aria-hidden, takže stačí jeden atribut.
     */
    const updateInert = (instance) => {
        instance.slides.forEach((slide) => {
            slide.inert = !slide.classList.contains('swiper-slide-active');
        });
    };

    const swiper = new Swiper(el, {
        loop: true,
        effect: 'fade',
        fadeEffect: {
            crossFade: true, // bez crossFade prosvítá pod odcházejícím slidem pozadí
        },
        speed: reduceMotion ? 0 : 700,
        slidesPerView: 1, // fade počítá s jedním slidem na obrazovku
        mousewheel: {
            forceToAxis: true, // jen vodorovné gesto (2 prsty doleva/doprava na trackpadu)
        },
        keyboard: {
            enabled: true,
            onlyInViewport: true, // šipky přepínají slidy, jen když je karusel vidět
        },
        pagination: {
            el: '.swiper-pagination-banners',
            clickable: true,
        },
        autoplay: reduceMotion ? false : {
            delay: 6000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
        },
        a11y: {
            prevSlideMessage: 'Předchozí slide',
            nextSlideMessage: 'Další slide',
            firstSlideMessage: 'Toto je první slide',
            lastSlideMessage: 'Toto je poslední slide',
            paginationBulletMessage: 'Přejít na slide {{index}}',
            slideLabelMessage: 'Slide {{index}} z {{slidesLength}}',
            slideRole: 'group',
            containerRoleDescriptionMessage: 'karusel',
            itemRoleDescriptionMessage: 'slide',
        },
        on: {
            init: updateInert,
            slideChangeTransitionStart: updateInert,
        },
    });

    if (!swiper.autoplay || !autoplayBtn) return;

    // Tlačítko dává smysl jen tehdy, když se opravdu něco točí
    autoplayBtn.hidden = false;

    // true = uživatel si přehrávání sám vypnul → nesmí se samo nahodit zpátky
    let userPaused = false;

    const setButtonState = (playing) => {
        // Viditelný text musí být obsažen v aria-label (WCAG 2.5.3 Label in Name)
        autoplayBtn.setAttribute(
            'aria-label',
            playing ? 'Pozastavit automatické přehrávání' : 'Spustit automatické přehrávání',
        );
        const icon = autoplayBtn.querySelector('.material-symbols-outlined');
        if (icon) icon.textContent = playing ? 'pause' : 'play_arrow';
        const text = autoplayBtn.querySelector('.banner-autoplay-text');
        if (text) text.textContent = playing ? 'Pozastavit' : 'Spustit';
        // aria-live přepíná Swiper sám; při pauze je vhodné hlásit změny slidu
        el.querySelector('.swiper-wrapper')?.setAttribute('aria-live', playing ? 'off' : 'polite');
    };

    autoplayBtn.addEventListener('click', () => {
        userPaused = !userPaused;
        if (userPaused) {
            swiper.autoplay.stop();
        } else {
            swiper.autoplay.start();
        }
        setButtonState(!userPaused);
    });

    // Pozastavení, když se uživatel proklikává obsahem slidu klávesnicí
    el.addEventListener('focusin', () => swiper.autoplay.stop());
    el.addEventListener('focusout', (event) => {
        if (userPaused) return; // respektuj vypnutí tlačítkem
        if (!el.contains(event.relatedTarget)) swiper.autoplay.start();
    });

    setButtonState(true);
}

document.addEventListener('DOMContentLoaded', initBanners);
